<template>
    <div>

        <section class="p-80-15 d-flex f-d-c gap40">

            <header>
                <label>Platforms & Frameworks</label>
                <h2 class="max-w-648">Choose your preferred platforms and frameworks</h2>
            </header>

            <div class="container">
                <div class="grid-flex">
                    <label v-for="tech in technologies" :for="('tech' + tech.name)"  class="option-tab flex-centered" @click="selectedTab(tech.name)" :class="{ 'tabchecked ': currentTab == tech.name }" :key="tech.id">
                        <input type="checkbox" :id="('tech' + tech.name)" :value="tech.name" v-model="selected_technologies" />
                        <div class="tab">
                            <div class="logo">
                                <svg class="abs" :width="tech.width" :height="tech.height">
                                    <use :xlink:href="'#'+tech.svgName"></use>
                                </svg>
                                <span class="close">
                                    <svg><use xlink:href="#close"></use></svg>
                                </span>
                            </div>
                            <h4>{{ tech.name }}</h4>
                        </div>
                    </label>
                </div>
                <p class="unsupported" v-if="unsupported.length">* We still don't support the following platform(s)/framework(s): {{ unsupported.join(', ') }}. But feel free to make a request, and we will make our best to make it available as soon as possible</p>
            </div>

        </section>

        <section class="p-80-15 d-flex f-d-c gap40">

            <header>
                <label>Symbologies</label>
                <h2 class="max-w-648">Choose your preferred symbologies</h2>
            </header>


            <div class="container">
                <div class="grid-flex">
                    <label v-for="(symName,symKey) in barcodes" :for="('ss_' + symKey)"  class="option-tab flex-centered" key="symName">
                        <input type="checkbox" :id="('ss_' + symKey)" :value="symName" v-model="selected_barcodes" />
                        <div class="tab">
                            <div class="logo">
                                <svg class="abs">
                                    <use v-if="['QR','DATAMATRIX','DOTCODE','PDF417','MRZ','VIN'].includes(symKey)" :xlink:href="'#'+symKey"></use>
                                    <use v-else xlink:href="#1d-all"></use>
                                </svg>
                                <span class="close">
                                    <svg><use xlink:href="#close"></use></svg>
                                </span>
                            </div>
                            <h4>{{ symName }}</h4>
                        </div>
                    </label>

                    <label class="option-tab flex-centered check-all" for="all-syms" key="all-syms">
                        <input type="checkbox" id="all-syms" value="all" :checked="selected_barcodes.length == Object.keys(barcodes).length" @change="toggleAllBarcodes" />
                        <div class="tab">
                            <div class="logo">
                                <svg class="abs">
                                    <use xlink:href="#check"></use>
                                </svg>
                                <span class="close">
                                    <svg><use xlink:href="#close"></use></svg>
                                </span>
                            </div>
                            <h4>Select All</h4>
                        </div>
                    </label>
                </div>
            </div>

            
<!-- 
            <transition-group tag="div" name="selected-complete" class="selected-items">
                <div v-if="selected_technologies.length" class="selected-complete-item">
                    <div class="row">
                        <div class="col-xs-11">
                            <h3>Platform(s) / Framework(s)</h3>
                            <p class="tomato-text grid-11">{{ selected_technologies.join(', ') }}</p>

                        </div>
                    </div>
                </div>
                <div v-if="selected_barcodes.length" class="selected-complete-item">
                    <div class="row">
                        <div class="col-xs-11">
                            <h3>Symbologies</h3>
                            <p class="tomato-text grid-11">{{ selected_barcodes.join(', ') }}</p>

                        </div>
                    </div>
                </div>
            </transition-group> -->
        </section>

        <Form id="contact-info" :selected_technologies="selected_technologies" :selected_barcodes="selected_barcodes" :logged_in="logged_in" :currentTab="currentTab"></Form>
    </div>
</template>

<script>
import { ref } from 'vue'
import Form from './Form.vue';
var general_config = require('../assets/general_config');
export default {
    components: {
        Form
    },
    setup(props) {
        
        let technologies = general_config.technologies;

        var sb = {};
        technologies.forEach(el => {
            sb[el.name] = []
        });

        let isUsedLloggedIn = false

        if(typeof logged_in != 'undefined'){
            isUsedLloggedIn = logged_in
        }

        return {
            logged_in : ref(isUsedLloggedIn),
            currentTab : ref('iOS'),
            technologies: technologies,
            barcodes: general_config.barcodes,
            unsupported_technologies: general_config.unsupported_technologies,
            selected_barcodes: ref([]),
            selected_technologies : ref([]),
        }
    },

    computed: {
        unsupported:function(){
            
            let self = this;

            return this.selected_technologies.filter(value => self.unsupported_technologies.includes(value));
        }
    },
    methods: {
        selectedTab(selectedTab) {

            this.currentTab = selectedTab;

        },
        toggleAllBarcodes(e) {

            if(this.selected_barcodes.length == Object.keys(this.barcodes).length){
                this.selected_barcodes = [];
            }
            else{

                this.selected_barcodes = [];

                for (let i in this.barcodes) {
                    this.selected_barcodes.push(this.barcodes[i].toString())

                }
            }
        }
    },
    mounted: function(){

        
    }

}

</script>